import ScrollReveal from './ScrollReveal';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className='px-6 py-28 md:py-40 md:px-8 bg-neutral-50'>
      <div className='mx-auto max-w-7xl'>
        <ScrollReveal>
          <div className='grid items-start gap-16 lg:grid-cols-2'>
            {/* LEFT */}

            <div className='max-w-xl'>
              {/* LABEL */}

              <p
                className='
                text-red-500
                uppercase
                tracking-[0.2em]
                text-xs
                mb-4
                font-medium
                '
              >
                About
              </p>

              {/* TITLE */}

              <h2
                className='
                text-[32px]
                sm:text-[40px]
                md:text-[48px]
                lg:text-[52px]
                font-semibold
                leading-tight
                tracking-tight
                mb-6
                '
              >
                Tomado Design Studio
              </h2>

              {/* DESCRIPTION */}

              <p
                className='mb-6 text-base leading-relaxed  text-neutral-700 md:text-lg'
              >
                토마도 디자인 스튜디오는 디자이너와 개발자가 함께하는 협업
                팀입니다.
                <br />
                보기 좋은 결과물에 그치지 않고, 실제로 작동하고 사용되는
                디자인을 만듭니다.
              </p>
            </div>

            {/* RIGHT */}

            <div className='grid gap-10 sm:grid-cols-2'>
              {/* DESIGN */}

              <div>
                <p
                  className='
                  text-xs
                  uppercase
                  tracking-[0.2em]
                  text-neutral-400
                  mb-3
                  '
                >
                  Design
                </p>

                <ul
                  className='space-y-2 text-lg font-medium  text-neutral-900'
                >
                  <li>Branding</li>
                  <li>UI Design</li>
                </ul>
              </div>

              {/* DEVELOPMENT */}

              <div>
                <p
                  className='
                  text-xs
                  uppercase
                  tracking-[0.2em]
                  text-neutral-400
                  mb-3
                  '
                >
                  Development
                </p>

                <ul
                  className='space-y-2 text-lg font-medium  text-neutral-900'
                >
                  <li>Publishing</li>
                  <li>Frontend</li>
                </ul>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default AboutSection;
